import { Navigate } from "@solidjs/router";
import {
  createContext,
  createMemo,
  type ParentProps,
  Show,
  useContext,
} from "solid-js";
import { useAiChatStore } from "../../store/AiChatProvider";
import { createRefineStore, type RefineStoreValue } from "./refineStore";

const RefineContext = createContext<RefineStoreValue>();

export function RefineProvider(props: ParentProps) {
  const aiChat = useAiChatStore();

  const store = createMemo(() => {
    const payload = aiChat.partialPayload;
    if (!payload) return null;
    return createRefineStore(payload);
  });

  return (
    <Show when={store()} fallback={<Navigate href="/job-offers/create/ai" />}>
      {(resolvedStore) => (
        <RefineContext.Provider value={resolvedStore()}>
          {props.children}
        </RefineContext.Provider>
      )}
    </Show>
  );
}

export function useRefineStore(): RefineStoreValue {
  const store = useContext(RefineContext);
  if (!store) {
    throw new Error("useRefineStore must be used within RefineProvider");
  }
  return store;
}
